// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pestaña «Rendimiento» de la ficha del ordenador. Prefijo \`wperf-\`. */

.wperf {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.wperf-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.wperf-ranges { display: flex; gap: 6px; flex-wrap: wrap; }

.wperf-chip {
  padding: 5px 12px;
  border-radius: 999px;
  border: 1px solid var(--border);
  background: var(--bg-card);
  color: var(--text-secondary);
  font: inherit;
  font-size: 0.8rem;
  cursor: pointer;
}

.wperf-chip:hover { border-color: var(--accent); color: var(--accent); }

.wperf-chip.is-on {
  border-color: var(--accent);
  background: rgba(var(--accent-rgb), 0.12);
  color: var(--accent-l, var(--accent));
  font-weight: 600;
}

.wperf-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.78rem;
  color: var(--text-muted);
}

.wperf-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: 1px solid var(--border);
  border-radius: 7px;
  background: var(--bg-card);
  color: var(--text-secondary);
  cursor: pointer;
}

.wperf-icon:hover { border-color: var(--accent); color: var(--accent); }
.wperf-icon svg { width: 14px; height: 14px; }

.wperf-alert {
  padding: 8px 12px;
  border-radius: 9px;
  border: 1px solid var(--red-600, #dc2626);
  background: color-mix(in srgb, var(--red-600, #dc2626) 10%, transparent);
  color: var(--red-700, #b91c1c);
  font-size: 0.84rem;
}

.wperf-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px 20px;
  color: var(--text-muted);
  text-align: center;
}

.wperf-empty svg { width: 42px; height: 42px; opacity: 0.55; }
.wperf-empty p { margin: 0; max-width: 52ch; font-size: 0.86rem; }

/* ── Agujas ─────────────────────────────────────────────────────────────── */

.wperf-gauges {
  display: flex;
  align-items: center;
  gap: 22px;
  flex-wrap: wrap;
}

.wperf-gauge { text-align: center; }
.wperf-gauge-label { font-size: 0.78rem; color: var(--text-secondary); margin-top: 2px; }
.wperf-gauge-sub { font-size: 0.72rem; color: var(--text-muted); }

.wperf-stat { text-align: center; padding-left: 6px; }
.wperf-stat-value { font-size: 1.2rem; font-weight: 700; color: var(--text-primary); font-variant-numeric: tabular-nums; }
.wperf-stat-label { font-size: 0.74rem; color: var(--text-muted); }

/* ── Gráficas ───────────────────────────────────────────────────────────── */

.wperf-chart { width: 100%; }
.wperf-chart-label { font-size: 0.74rem; color: var(--text-muted); margin-bottom: 2px; }
.wperf-chart-box { width: 100%; min-height: 182px; color: var(--text-muted); }

/* ── Discos ─────────────────────────────────────────────────────────────── */

.wperf-vols { display: flex; flex-direction: column; gap: 10px; }
.wperf-vol-head { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; }
.wperf-vol-head b { font-size: 0.85rem; color: var(--text-primary); }
.wperf-vol-pct { font-size: 0.8rem; font-weight: 600; font-variant-numeric: tabular-nums; }

.wperf-bar {
  height: 7px;
  border-radius: 999px;
  background: var(--slate-100);
  overflow: hidden;
  margin: 4px 0 3px;
}

.wperf-bar-fill { height: 100%; border-radius: 999px; transition: width 0.35s ease; }
.wperf-vol-sub { font-size: 0.74rem; color: var(--text-muted); }

/* ── Red ────────────────────────────────────────────────────────────────── */

.wperf-table { display: flex; flex-direction: column; }

.wperf-tr {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr 0.8fr 1.4fr 0.6fr;
  gap: 10px;
  align-items: center;
  padding: 6px 2px;
  border-bottom: 1px solid var(--border);
  font-size: 0.82rem;
  color: var(--text-secondary);
}

.wperf-tr:last-child { border-bottom: 0; }

.wperf-tr--head {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--text-muted);
  font-weight: 600;
}

.wperf-nic { font-weight: 600; color: var(--text-primary); }

/* ── Servicios ──────────────────────────────────────────────────────────── */

.wperf-services { display: flex; flex-direction: column; gap: 2px; max-height: 320px; overflow: auto; }

.wperf-service {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 2px;
  font-size: 0.82rem;
  border-bottom: 1px solid var(--border);
}

.wperf-service:last-child { border-bottom: 0; }
.wperf-service-name { flex: 1 1; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.wperf-service-status { color: var(--text-muted); font-size: 0.74rem; }

.wperf-dot { width: 8px; height: 8px; border-radius: 50%; flex: none; }
.wperf-dot.is-on { background: var(--green-600, #16a34a); }
.wperf-dot.is-off { background: var(--red-600, #dc2626); }

@media (prefers-reduced-motion: reduce) {
  .wperf-bar-fill { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/WorkstationPerformance.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA,gBAAgB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;;AAE1D;EACE,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA,oBAAoB,2BAA2B,EAAE,oBAAoB,EAAE;;AAEvE;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,oBAAoB,2BAA2B,EAAE,oBAAoB,EAAE;AACvE,kBAAkB,WAAW,EAAE,YAAY,EAAE;;AAE7C;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,wEAAwE;EACxE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,mBAAmB,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE;AAC7D,iBAAiB,SAAS,EAAE,eAAe,EAAE,kBAAkB,EAAE;;AAEjE,8EAA8E;;AAE9E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,eAAe,kBAAkB,EAAE;AACnC,qBAAqB,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AACxF,mBAAmB,kBAAkB,EAAE,wBAAwB,EAAE;;AAEjE,cAAc,kBAAkB,EAAE,iBAAiB,EAAE;AACrD,oBAAoB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,kCAAkC,EAAE;AACzH,oBAAoB,kBAAkB,EAAE,wBAAwB,EAAE;;AAElE,8EAA8E;;AAE9E,eAAe,WAAW,EAAE;AAC5B,qBAAqB,kBAAkB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE;AACvF,mBAAmB,WAAW,EAAE,iBAAiB,EAAE,wBAAwB,EAAE;;AAE7E,8EAA8E;;AAE9E,cAAc,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAChE,kBAAkB,aAAa,EAAE,qBAAqB,EAAE,8BAA8B,EAAE,QAAQ,EAAE;AAClG,oBAAoB,kBAAkB,EAAE,0BAA0B,EAAE;AACpE,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,kCAAkC,EAAE;;AAE1F;EACE,WAAW;EACX,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,kBAAkB,YAAY,EAAE,oBAAoB,EAAE,4BAA4B,EAAE;AACpF,iBAAiB,kBAAkB,EAAE,wBAAwB,EAAE;;AAE/D,8EAA8E;;AAE9E,eAAe,aAAa,EAAE,sBAAsB,EAAE;;AAEtD;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,uBAAuB,gBAAgB,EAAE;;AAEzC;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,aAAa,gBAAgB,EAAE,0BAA0B,EAAE;;AAE3D,8EAA8E;;AAE9E,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,cAAc,EAAE;;AAEtG;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,4BAA4B,gBAAgB,EAAE;AAC9C,sBAAsB,SAAO,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC3H,wBAAwB,wBAAwB,EAAE,kBAAkB,EAAE;;AAEtE,aAAa,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,UAAU,EAAE;AACtE,mBAAmB,qCAAqC,EAAE;AAC1D,oBAAoB,mCAAmC,EAAE;;AAEzD;EACE,kBAAkB,gBAAgB,EAAE;AACtC","sourcesContent":["/* Pestaña «Rendimiento» de la ficha del ordenador. Prefijo `wperf-`. */\r\n\r\n.wperf {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.wperf-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.wperf-ranges { display: flex; gap: 6px; flex-wrap: wrap; }\r\n\r\n.wperf-chip {\r\n  padding: 5px 12px;\r\n  border-radius: 999px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-card);\r\n  color: var(--text-secondary);\r\n  font: inherit;\r\n  font-size: 0.8rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.wperf-chip:hover { border-color: var(--accent); color: var(--accent); }\r\n\r\n.wperf-chip.is-on {\r\n  border-color: var(--accent);\r\n  background: rgba(var(--accent-rgb), 0.12);\r\n  color: var(--accent-l, var(--accent));\r\n  font-weight: 600;\r\n}\r\n\r\n.wperf-meta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 0.78rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.wperf-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 26px;\r\n  height: 26px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 7px;\r\n  background: var(--bg-card);\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n}\r\n\r\n.wperf-icon:hover { border-color: var(--accent); color: var(--accent); }\r\n.wperf-icon svg { width: 14px; height: 14px; }\r\n\r\n.wperf-alert {\r\n  padding: 8px 12px;\r\n  border-radius: 9px;\r\n  border: 1px solid var(--red-600, #dc2626);\r\n  background: color-mix(in srgb, var(--red-600, #dc2626) 10%, transparent);\r\n  color: var(--red-700, #b91c1c);\r\n  font-size: 0.84rem;\r\n}\r\n\r\n.wperf-empty {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 40px 20px;\r\n  color: var(--text-muted);\r\n  text-align: center;\r\n}\r\n\r\n.wperf-empty svg { width: 42px; height: 42px; opacity: 0.55; }\r\n.wperf-empty p { margin: 0; max-width: 52ch; font-size: 0.86rem; }\r\n\r\n/* ── Agujas ─────────────────────────────────────────────────────────────── */\r\n\r\n.wperf-gauges {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 22px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.wperf-gauge { text-align: center; }\r\n.wperf-gauge-label { font-size: 0.78rem; color: var(--text-secondary); margin-top: 2px; }\r\n.wperf-gauge-sub { font-size: 0.72rem; color: var(--text-muted); }\r\n\r\n.wperf-stat { text-align: center; padding-left: 6px; }\r\n.wperf-stat-value { font-size: 1.2rem; font-weight: 700; color: var(--text-primary); font-variant-numeric: tabular-nums; }\r\n.wperf-stat-label { font-size: 0.74rem; color: var(--text-muted); }\r\n\r\n/* ── Gráficas ───────────────────────────────────────────────────────────── */\r\n\r\n.wperf-chart { width: 100%; }\r\n.wperf-chart-label { font-size: 0.74rem; color: var(--text-muted); margin-bottom: 2px; }\r\n.wperf-chart-box { width: 100%; min-height: 182px; color: var(--text-muted); }\r\n\r\n/* ── Discos ─────────────────────────────────────────────────────────────── */\r\n\r\n.wperf-vols { display: flex; flex-direction: column; gap: 10px; }\r\n.wperf-vol-head { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; }\r\n.wperf-vol-head b { font-size: 0.85rem; color: var(--text-primary); }\r\n.wperf-vol-pct { font-size: 0.8rem; font-weight: 600; font-variant-numeric: tabular-nums; }\r\n\r\n.wperf-bar {\r\n  height: 7px;\r\n  border-radius: 999px;\r\n  background: var(--slate-100);\r\n  overflow: hidden;\r\n  margin: 4px 0 3px;\r\n}\r\n\r\n.wperf-bar-fill { height: 100%; border-radius: 999px; transition: width 0.35s ease; }\r\n.wperf-vol-sub { font-size: 0.74rem; color: var(--text-muted); }\r\n\r\n/* ── Red ────────────────────────────────────────────────────────────────── */\r\n\r\n.wperf-table { display: flex; flex-direction: column; }\r\n\r\n.wperf-tr {\r\n  display: grid;\r\n  grid-template-columns: 1.2fr 0.8fr 0.8fr 1.4fr 0.6fr;\r\n  gap: 10px;\r\n  align-items: center;\r\n  padding: 6px 2px;\r\n  border-bottom: 1px solid var(--border);\r\n  font-size: 0.82rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.wperf-tr:last-child { border-bottom: 0; }\r\n\r\n.wperf-tr--head {\r\n  font-size: 0.72rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  color: var(--text-muted);\r\n  font-weight: 600;\r\n}\r\n\r\n.wperf-nic { font-weight: 600; color: var(--text-primary); }\r\n\r\n/* ── Servicios ──────────────────────────────────────────────────────────── */\r\n\r\n.wperf-services { display: flex; flex-direction: column; gap: 2px; max-height: 320px; overflow: auto; }\r\n\r\n.wperf-service {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 3px 2px;\r\n  font-size: 0.82rem;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.wperf-service:last-child { border-bottom: 0; }\r\n.wperf-service-name { flex: 1; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\r\n.wperf-service-status { color: var(--text-muted); font-size: 0.74rem; }\r\n\r\n.wperf-dot { width: 8px; height: 8px; border-radius: 50%; flex: none; }\r\n.wperf-dot.is-on { background: var(--green-600, #16a34a); }\r\n.wperf-dot.is-off { background: var(--red-600, #dc2626); }\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .wperf-bar-fill { transition: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
